export enum AccountingDatatype {
Number,
String,
Boolean,
DateTime,
Collection,
ObjectInstance,
}
